import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list-down-primary--sprite",
  "use": "list-down-primary--sprite-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"list-down-primary--sprite\">\n<path d=\"M7.91 8.29498L12.5 12.875L17.09 8.29498L18.5 9.70498L12.5 15.705L6.5 9.70498L7.91 8.29498Z\" fill=\"var(--Text-primary)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol